export default __webpack_public_path__ + "static/media/OECD-color.f5b77411.png";